const ICON_KEYS = [
    "horse", "dragon", "snake", "foot", "rabbit", "stump", "fox", "tiger",
    "ox", "sheep", "elephant", "frog", "crane", "rooster", "snow", "charcoal",
    "bow", "boat", "sword", "cup", "pearl", "bell", "paper", "bamboo",
    "water", "stone", "mountain", "sea", "flower", "fire", "moon", "star",
    "door", "cart", "books", "needle", "heart", "mouth", "hand", "eye",
    "ear", "coins", "rice", "wind", "rain", "road", "house", "scholar",
    "dance", "trophy", "walk", "sleep", "eat", "talk", "farmer", "fight",
    "lift", "hide", "paint", "guqin", "archer", "study", "plant", "run",
    "up7", "down8", "compass4", "compass8", "fence", "thoughts", "sheng", "box",
    "blindfold", "well", "silk", "south", "north", "deer", "monkey", "blue_dye",
    "green_dye", "plum", "cake", "medicine", "guest", "lips", "teeth", "mouse",
    "market", "flag", "oil", "dog", "soil_basket", "melon", "date", "candy",
    "one_action", "two_rewards",
    "hair", "five_lakes", "four_seas", "sheng_group", "bamboo_plan", "old_man", "jingwei",
    "broken_cauldron", "new_scene", "humble_question", "medicine_no_effect",
] as const;

export type IconKey = typeof ICON_KEYS[number];

const CLEAN_ICON_FILES: Partial<Record<IconKey, string>> = {
    walk: "walk_clean",
    ox: "ox_clean",
    paint: "paint_clean",
    lift: "lift_clean",
    mountain: "mountain_clean",
    farmer: "farmer_clean",
};

export class ClueImages {
    static readonly ASSETS = ICON_KEYS.map(key => this.path(key));

    static forKey(key: IconKey): string {
        return this.path(key);
    }

    private static path(key: IconKey): string {
        const fileName = CLEAN_ICON_FILES[key] ?? key;
        return `resources/clues/icons/${fileName}.png`;
    }
}
